export default {"src":"/_next/static/media/clock.305b68ac.svg","height":20,"width":20};